import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { priceListCustomer, priceListCustomerType } from '../../types/slices/priceListCustomerType'

const initialState: priceListCustomerType =
{
    status: ApiStatus.FETCHED,
    priceListCustomer: [],
    priceListSelectedCustomer: {} as priceListCustomer,
    errorMessage: undefined,
    action: ''
}

const priceListCustomerSlice = createSlice({
    name: 'priceListCustomerSlice',
    initialState,
    reducers: {
        onFetchPriceListCustomer (state, { payload }: { payload: priceListCustomer[]}) {
            state.status = ApiStatus.FETCHED
            state.priceListCustomer = payload
            state.errorMessage = undefined
        },
        onSetSelectedPriceListCustomer (state, { payload }: { payload: priceListCustomer }) {
            state.priceListSelectedCustomer = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectPriceListCustomerState = (state: RootState) => state.priceListCustomerSlice
export default priceListCustomerSlice.reducer
export const {
    onFetchPriceListCustomer,
    onSetSelectedPriceListCustomer,
    changeStatus,
    setAction,
} = priceListCustomerSlice.actions
